import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  display: flex;
  align-items: start;
  flex-direction: column;

  background-color: ${(props) => props.theme.colors.greys.lightest};
`;

export const Title = styled.div`
  color: ${(props) => props.theme.colors.greys.darkest};
  font: ${(props) => props.theme.fonts.h3Bold700};
`;

export const Subtitle = styled.div`
  color: ${(props) => props.theme.colors.greys.darker};
  font: ${(props) => props.theme.fonts?.textSmallHeight14};
`;
